import Vue from 'vue'
import VueI18n from 'vue-i18n'

import messages from './assets/literales.json'


Vue.use(VueI18n)

export default new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'es',
  messages, // set locale messages
  silentTranslationWarn: true
})


